<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-25 13:37:34
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-04-27 13:31:27
 * @Description:
-->
<template>
  <main class="qll-content">
    <Header />
    <div class="qll-content_body">
      <router-view />
    </div>
  </main>
</template>

<script>
import Header from './header.vue'
export default {
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
.qll-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.qll-content_body {
  flex: 1;
  overflow: hidden;
  background: url('~@/assets/img/plc/bg2.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}
</style>
